import { render, staticRenderFns } from "./SingleUser.vue?vue&type=template&id=3b06efe5&scoped=true&"
import script from "./SingleUser.vue?vue&type=script&lang=js&"
export * from "./SingleUser.vue?vue&type=script&lang=js&"
import style0 from "./SingleUser.vue?vue&type=style&index=0&id=3b06efe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b06efe5",
  null
  
)

export default component.exports